import { APP_CONSTANT } from '../constants/AppConstants';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';

const initialState = {
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case APP_CONSTANT.INIT_APP:
            return {
                ...state,
                appData: {
                    showMask: false,
                    toggleMoreInstruction: false,
                    homePage: GLOBAL_CONSTANTS.ISSUE_LISTING
                }
            }
        case APP_CONSTANT.SHOW_LOADING:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    showMask: true
                })
            }
        case APP_CONSTANT.HIDE_LOADING:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    showMask: false
                })
            }
        case APP_CONSTANT.LOAD_ISSUE_LISTING:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    issueList: action.payload.data
                })
            }
        case APP_CONSTANT.ADD_ISSUE_COLLECTOR_IN_LISTING: 
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    issueList: [...state.appData.issueList, action.issuecollector]
                })
            }
        case APP_CONSTANT.SET_HEADER_HEIGHT:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    headerHeight: action.height
                })
            }
        case APP_CONSTANT.CHANGE_HOME_PAGE:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    homePage: action.pageName
                })
            }
        case APP_CONSTANT.UPDATE_IC_IN_LISTING:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    issueList: state.appData.issueList.map( ic => (
                        ic.id === action.config.id ? {
                            ...ic,
                            ...action.config
                        }  : ic
                    ) )
                })
            }
        case APP_CONSTANT.DELETE_ISSUE_COLLECTOR:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    issueList: state.appData.issueList.filter( ic => ic.id !== action.id )
                })
            }
        case APP_CONSTANT.CHANGE_ISSUE_COLLECTOR_STATUS:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    issueList: state.appData.issueList.map( ic => (
                        ic.id === action.id ? {
                            ...ic,
                            status: action.status
                        } : ic
                    ) )
                })
            }
		case APP_CONSTANT.OPEN_CARDTYPE_SETTINGS:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    isCardTypeConfigOpen: true
                })
            }

        case APP_CONSTANT.CLOSE_CARDTYPE_SETTINGS:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    isCardTypeConfigOpen: false
                })
            }
        case APP_CONSTANT.OPEN_OUTLOOK_SETTINGS:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    isOutlookConfigOpen: true,
                    pluginType: action.pluginType
                })
            }
        case APP_CONSTANT.CLOSE_OUTLOOK_SETTINGS:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    isOutlookConfigOpen: false,
                    pluginType: undefined
                })
            }
        case APP_CONSTANT.TOGGLE_MORE_INSTRUCTION:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    toggleMoreInstruction: !state.appData.toggleMoreInstruction
                })
            }
        case GLOBAL_CONSTANTS.ADD_CUSTOM_INLINE_STYLE:
            return {
                ...state,
                appData: Object.assign({}, state.appData, {
                    rtfInlineStyle: action.payload.data
                })
            }
        default:
            return state;
    }
};

export default appReducer;